import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { CoverageApi } from '../../apis/coverage-api';
import type { IGetIndicatorListParams } from '../../types/index';
import type { CoverageRepository } from '../../services/coverage-repository';

@injectable()
export class CoverageRepositoryImpl implements CoverageRepository {
    constructor(
        @inject(CoverageApi) private coverageApi: CoverageApi
    ) {
    }

    getIndicatorList(params?: IGetIndicatorListParams) {
        return this.coverageApi.getIndicatorList(params);
    }
}
